import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import {AppContainer} from "./components/A0_App/AppContainer";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppContainer />
  </React.StrictMode>
);

reportWebVitals();
